import { render, staticRenderFns } from "./DnaKit.vue?vue&type=template&id=171661ce&"
import script from "./DnaKit.vue?vue&type=script&lang=js&"
export * from "./DnaKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports